import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "/api/audio";
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

const TZ = "America/Sao_Paulo";

export function fmtErr(e) {
  return e?.response?.data?.detail || e?.message || "Erro inesperado";
}

// Normaliza string ISO sem timezone para UTC antes de converter
function toDate(ts) {
  if (typeof ts === "number") return new Date(ts * 1000);
  if (!ts) return null;
  // Se não tem Z nem offset (+/-), adiciona Z para forçar interpretação UTC
  const s = String(ts);
  const normalized = /[Z+\-]\d*$/.test(s.slice(10)) ? s : s + "Z";
  return new Date(normalized);
}

export function fmtTs(ts) {
  if (!ts) return "—";
  try {
    const d = toDate(ts);
    return d.toLocaleString("pt-BR", { timeZone: TZ, hour: "2-digit", minute: "2-digit", second: "2-digit" });
  } catch { return String(ts); }
}

export function fmtDate(ts) {
  if (!ts) return "—";
  try {
    const d = toDate(ts);
    return d.toLocaleString("pt-BR", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return String(ts); }
}

export function secsAgo(ts) {
  if (!ts) return "—";
  const d = toDate(ts);
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diff < 60) return `${diff}s atrás`;
  if (diff < 3600) return `${Math.floor(diff / 60)}min atrás`;
  return `${Math.floor(diff / 3600)}h atrás`;
}
